import { types } from "mobx-state-tree";

// The API serializes unset properties as explicit `null` — Newtonsoft is configured with
// ReferenceLoopHandling only, so NullValueHandling stays at its `Include` default and a
// nullable/unassigned C# property arrives as `"field": null` rather than being omitted.
//
// `types.optional(type, default)` substitutes its default for `undefined` ONLY; it rejects
// `null` and throws while converting the snapshot. The third `optionalValues` argument makes
// `null` map to the default too.
//
// These deliberately keep the field type non-nullable (`string`/`number`/`boolean`) instead of
// using `types.maybeNull`, which would store the null and force null-handling on every reader.
export const nullableString = (def = "") => types.optional(types.string, def, [undefined, null]);
export const nullableNumber = (def = 0) => types.optional(types.number, def, [undefined, null]);
export const nullableBoolean = (def = false) => types.optional(types.boolean, def, [undefined, null]);
